export default "__VITE_ASSET__zZMuLiSM__"